import { createQueryString } from '../utilities/utilities';
import { checkEmailPath } from '../utilities/api_relative_paths';
import { RESET_PASSWORD_PATH } from '../utilities/devex_paths';

interface Response {
  value: string;
  valid: boolean;
  message: string;
}

const checkIfEmailExists = (email: string): Promise<Response> => {
  if (!email) return Promise.reject('Missing param: Email');

  const options = {
    field: 'email',
    mode: 'password',
    value: email,
  };

  return fetch(checkEmailPath + createQueryString(options))
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

const initiatePasswordRequest = (email: string): Promise<null> => {
  const authTokenSelector = document.querySelector('meta[name="csrf-token"]');
  const authToken = authTokenSelector ? authTokenSelector.getAttribute('content') : null;

  if (!authToken) return Promise.reject('Invalid CSRF token');
  if (!email) return Promise.reject('Missing param: Email');

  const options = {
    body: JSON.stringify({ email: email }),
    method: 'POST',
    headers: {
      'X-CSRF-Token': authToken,
      'Content-Type': 'application/json',
    },
  };

  return fetch(RESET_PASSWORD_PATH, options)
    .then((response) => {
      // Because this POST request returns HTML, we don't need to be able to chain any subsequent
      // code to it on success. If response.ok is false, we need to manually reject the promise.
      if (response.ok) return null;
      return Promise.reject(response);
    })
    .catch((error) => Promise.reject(error));
};

export { checkIfEmailExists, initiatePasswordRequest };
